import { React, Link, TextInput2 as TextInput, DropDown2 as DropDown } from "../../../../common";

const RenderChildIncome = (props) => {
  const { path, item, count, sourcetypes, onInputChanged } = props;

  const OnDeleteClicked = (e) => {
    e.preventDefault();
    if (onInputChanged) onInputChanged(`${path}.delete`.replace(/\./g, '_'), true);
  }

  return (
    <>
      {count > 1 && (
        <div className="formPartition">
          <div className="closePartition">
            <Link to="#" onClick={(e) => OnDeleteClicked(e)}>&#x2715; &nbsp;Delete</Link>
          </div>
        </div>
      )}
      <ul className="formContentIIcol">
        <li className="formContentIIcol">
          <div className="form1003ContentHead">Income Source</div>
          <div className="form_dollaricon icon"></div>
          <DropDown
            path={`${path}.description`}
            value={item?.description}
            items={sourcetypes}
            displayName={"text"}
            displayValue={"value"}
            onInputChildChanged={onInputChanged}
          />
        </li>
        <li className="formContentIIcol">
          <div className="form1003ContentHead">Monthly Income</div>
          <div className="form_dollaricon icon"></div>
          <TextInput
            path={`${path}.monthlyAmount`}
            value={item?.monthlyAmount}
            valuetype={"FINANCE"}
            onInputChildChanged={onInputChanged}
          />
        </li>
      </ul>
    </>
  );
};

const Component = (props) => {
  const { items, sourcetypes, onAddArrayList, onInputChanged } = props;

  const item = items && items.childs && items.childs.length > 0 ? items.childs[0] : null;

  const OnAddNewIncome = (e) => {
    e.preventDefault();
    let obj = {
      title: item?.title,
      owner: item?.owner,
      delete: false
    };
    if (onAddArrayList) onAddArrayList('incomesources', obj);
  };

  return (
    <>
      <div className="form1003BlkHead">
        <div className="formHeadContent">{item?.title}</div>
        <div className="form1003Blk_right">
          <input
            type="button"
            defaultValue="&#65291; Add Another"
            className="headRight_button"
            onClick={(e) => OnAddNewIncome(e)}
          />
        </div>
      </div>
      <div className="form1003ContentBlk">
        {items && items.childs && items.childs.map((x) => {
          if (!x.delete) {
            return (
              <RenderChildIncome
                count={items.childs.filter((x) => !x.delete).length}
                key={x.index}
                path={`incomesources.${x.index}`}
                item={x}
                sourcetypes={sourcetypes}
                onInputChanged={onInputChanged}
              />
            )
          } else { return null }
        })}
      </div>
    </>
  );
};

export default Component;
